import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Search, BookOpen, ArrowRight, TrendingUp } from 'lucide-react';
import { useQuery } from '@tanstack/react-query';
import api from '../../api/public';

const COVERS = ['#0f2044','#042d1e','#2d1d06','#1a0d2e','#0a1f2e','#2d0a0a'];
const CCOLORS = ['#60a5fa','#34d399','#fbbf24','#a78bfa','#38bdf8','#f87171'];

export default function OpacHomePage() {
  const [q, setQ] = useState('');
  const navigate = useNavigate();

  const { data: newBooks } = useQuery({
    queryKey: ['opac-new-books'],
    queryFn: () => api.get('/books?limit=8&sort=newest'),
  } as any);

  const { data: stats } = useQuery({
    queryKey: ['opac-stats'],
    queryFn: () => api.get('/stats'),
  } as any);

  const books = (newBooks as any)?.data?.books || [];
  const s = (stats as any)?.data;

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (q.trim()) navigate(`/opac/catalog?q=${encodeURIComponent(q)}`);
  };

  return (
    <div>
      <div style={{
        background:'linear-gradient(135deg, #0f2044 0%, #1a0d2e 50%, #042d1e 100%)',
        borderRadius:16, margin:'32px 0', padding:'64px 40px', textAlign:'center',
        border:'1px solid #1e2d45', position:'relative', overflow:'hidden'
      }}>
        <div style={{position:'absolute',top:0,left:0,right:0,bottom:0,opacity:0.05,
          backgroundImage:'radial-gradient(circle at 20% 50%, #60a5fa 0%, transparent 50%), radial-gradient(circle at 80% 50%, #a78bfa 0%, transparent 50%)'}} />
        <div style={{position:'relative'}}>
          <div style={{display:'flex',alignItems:'center',justifyContent:'center',gap:8,marginBottom:16}}>
            <BookOpen size={28} style={{color:'#60a5fa'}} />
            <span style={{fontSize:13,color:'#60a5fa',fontWeight:500,letterSpacing:'0.1em',textTransform:'uppercase'}}>SANGU ბიბლიოთეკა</span>
          </div>
          <h1 style={{fontSize:40,fontWeight:800,color:'#f1f5f9',margin:'0 0 12px',lineHeight:1.2}}>
            გამარჯობა, მკითხველო! 📚
          </h1>
          <p style={{fontSize:16,color:'#64748b',marginBottom:32,maxWidth:500,margin:'0 auto 32px'}}>
            {s?.books?.toLocaleString() || '15,000'}+ წიგნი შენი ხელმისაწვდომია
          </p>
          <form onSubmit={handleSearch} style={{maxWidth:560,margin:'0 auto',position:'relative'}}>
            <Search size={20} style={{position:'absolute',left:18,top:'50%',transform:'translateY(-50%)',color:'#475569'}} />
            <input value={q} onChange={e => setQ(e.target.value)}
              placeholder="მოძებნე სათაური, ავტორი, ISBN..."
              style={{width:'100%',background:'rgba(255,255,255,0.05)',border:'1px solid #2a3f6e',borderRadius:32,
                padding:'16px 140px 16px 52px',fontSize:15,color:'#e2e8f0',outline:'none',boxSizing:'border-box',backdropFilter:'blur(10px)'}} />
            <button type="submit"
              style={{position:'absolute',right:6,top:'50%',transform:'translateY(-50%)',background:'#1d4ed8',
                border:'none',borderRadius:24,padding:'10px 24px',fontSize:14,fontWeight:600,color:'white',cursor:'pointer'}}>
              ძიება
            </button>
          </form>
          <div style={{display:'flex',justifyContent:'center',gap:24,marginTop:24}}>
            {[
              {label:'წიგნი', val:s?.books?.toLocaleString()||'...', color:'#60a5fa'},
              {label:'წევრი', val:s?.members?.toLocaleString()||'...', color:'#34d399'},
              {label:'გაცემული', val:s?.active_checkouts?.toLocaleString()||'...', color:'#fbbf24'},
            ].map(st => (
              <div key={st.label} style={{textAlign:'center'}}>
                <div style={{fontSize:24,fontWeight:700,color:st.color}}>{st.val}</div>
                <div style={{fontSize:12,color:'#475569'}}>{st.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div style={{marginBottom:40}}>
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:20}}>
          <div style={{display:'flex',alignItems:'center',gap:8}}>
            <TrendingUp size={18} style={{color:'#60a5fa'}} />
            <h2 style={{fontSize:18,fontWeight:600,color:'#f1f5f9',margin:0}}>ახლად დამატებული</h2>
          </div>
          <Link to="/opac/catalog" style={{display:'flex',alignItems:'center',gap:4,fontSize:13,color:'#60a5fa',textDecoration:'none'}}>
            ყველა <ArrowRight size={14}/>
          </Link>
        </div>

        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))',gap:16}}>
          {books.map((b: any, i: number) => {
            const ci = i % 6;
            return (
              <Link key={b.id} to={`/opac/book/${b.id}`} style={{textDecoration:'none'}}>
                <div style={{background:'#0d1424',border:'1px solid #1e2d45',borderRadius:10,overflow:'hidden',transition:'transform 0.2s, border-color 0.2s',cursor:'pointer'}}
                  onMouseEnter={e => { (e.currentTarget as any).style.transform='translateY(-4px)'; (e.currentTarget as any).style.borderColor='#2a3f6e'; }}
                  onMouseLeave={e => { (e.currentTarget as any).style.transform='translateY(0)'; (e.currentTarget as any).style.borderColor='#1e2d45'; }}>
                  {b.cover_url ? (
                    <img src={b.cover_url} alt={b.title}
                      style={{width:'100%',height:200,objectFit:'cover',display:'block'}}
                      onError={e => { (e.target as any).style.display='none'; }} />
                  ) : (
                    <div style={{height:200,background:COVERS[ci],display:'flex',alignItems:'center',justifyContent:'center',fontSize:48,fontWeight:700,color:CCOLORS[ci]}}>
                      {(b.title||'?')[0]}
                    </div>
                  )}
                  <div style={{padding:12}}>
                    <div style={{fontSize:13,fontWeight:500,color:'#cbd5e1',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',marginBottom:4}}>{b.title}</div>
                    <div style={{fontSize:11,color:'#475569',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{b.author||'—'}</div>
                    <div style={{marginTop:8}}>
                      <span style={{padding:'2px 8px',borderRadius:4,fontSize:10,fontWeight:500,
                        background:b.available_copies>0?'#042d1e':'#2d0a0a',
                        color:b.available_copies>0?'#34d399':'#f87171'}}>
                        {b.available_copies>0?'ხელმისაწვდომი':'გაცემული'}
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>

      <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:16,marginBottom:40}}>
        {[
          {icon:'📖', title:'კატალოგი', desc:'15,000+ წიგნი ყველა ჟანრში', link:'/opac/catalog', color:'#0f2044', border:'#1e3a6e', btn:'#1d4ed8'},
          {icon:'🔍', title:'სწრაფი ძიება', desc:'ISBN, სათაური, ავტორი', link:'/opac/catalog', color:'#1a0d2e', border:'#3a1d6e', btn:'#7c3aed'},
          {icon:'👤', title:'ჩემი ბიბლიოთეკა', desc:'გაცემები და ჯარიმები', link:'/opac/my', color:'#042d1e', border:'#0a4a2a', btn:'#059669'},
        ].map(card => (
          <Link key={card.title} to={card.link} style={{textDecoration:'none'}}>
            <div style={{background:card.color,border:`1px solid ${card.border}`,borderRadius:12,padding:24,transition:'transform 0.2s'}}
              onMouseEnter={e => (e.currentTarget.style.transform='translateY(-2px)')}
              onMouseLeave={e => (e.currentTarget.style.transform='translateY(0)')}>
              <div style={{fontSize:32,marginBottom:12}}>{card.icon}</div>
              <div style={{fontSize:16,fontWeight:600,color:'#f1f5f9',marginBottom:6}}>{card.title}</div>
              <div style={{fontSize:13,color:'#64748b'}}>{card.desc}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
